import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
} from "recharts";
import { CHART_COLORS } from "./config/chart-config";
import { CustomLegend } from "./custom-legend";
import { CustomTooltip } from "./custom-tooltip";
import { ChartWrapper } from "./chart-wrapper";
import { useChartTheme } from "./hooks/useChartTheme";
import type { FC } from "react";

interface MonthlyTrend {
  readonly month: string;
  readonly total: number;
  readonly cumulative?: number;
  [key: string]: number | string | undefined;
}

/**
 * Displays organization growth trends over time using a line chart.
 */
export const GrowthChart: FC<{ data: readonly MonthlyTrend[] }> = ({
  data,
}) => {
  const { isDark, chartProps } = useChartTheme();
  const primaryColor = CHART_COLORS[isDark ? "dark" : "light"].primary;

  return (
    <ChartWrapper>
      <LineChart data={[...data]}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="month" />
        <YAxis />
        <Tooltip content={<CustomTooltip />} {...chartProps.tooltip} />
        <Legend content={<CustomLegend />} {...chartProps.legend} />
        <Line
          type="monotone"
          dataKey="total"
          stroke={primaryColor}
          strokeWidth={2}
          dot={{ fill: primaryColor }}
          name="Organizations"
        />
      </LineChart>
    </ChartWrapper>
  );
};
